import { render, staticRenderFns } from "./DropdownGroupOption.vue?vue&type=template&id=151b4a51"
import script from "./DropdownGroupOption.vue?vue&type=script&lang=js"
export * from "./DropdownGroupOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports